import { render, staticRenderFns } from "./CriticalComponentList.vue?vue&type=template&id=4b84c18e&scoped=true"
import script from "./CriticalComponentList.vue?vue&type=script&lang=js"
export * from "./CriticalComponentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84c18e",
  null
  
)

export default component.exports